module.exports = __webpack_public_path__ + "img/vko5.7478c075.jpg";